module.exports = __webpack_public_path__ + "static/media/we fav icon.c4c9b703.svg";